export const groupSortingColumns = [
    'name',
    'companiesCount',
    'policiesCount',
    'acceptanceRate',
];
export var GroupImportFailureReason;
(function (GroupImportFailureReason) {
    GroupImportFailureReason["UnknownInsuranceCompany"] = "unknown_insurance_company";
    GroupImportFailureReason["PolicyNotFound"] = "policy_not_found";
})(GroupImportFailureReason || (GroupImportFailureReason = {}));
